"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMING = exports.PAGE_VIEW = exports.INTERACTION = exports.DATA_INITIALIZED = void 0;
exports.default = reducer;
exports.initSingleBeaconAnalytics = exports.initGtmAnalytics = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));
var _excluded = ["coreData"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PAGE_VIEW = exports.PAGE_VIEW = 'PAGE_VIEW';
var DATA_INITIALIZED = exports.DATA_INITIALIZED = 'DATA_INITIALIZED';
var INTERACTION = exports.INTERACTION = 'INTERACTION';
var TIMING = exports.TIMING = 'TIMING';
var EVENTS_TO_IGNORE = [DATA_INITIALIZED, INTERACTION, TIMING];

/*
nui common attributes for beacon ping
*/
var getBeaconParams = function getBeaconParams(initialSet, evtType, window, document, location, params) {
  var beaconParams = {
    v: 1,
    t: evtType,
    cid: initialSet.userId,
    z: new Date().getTime(),
    dt: document.title,
    de: document.characterSet,
    dp: location.pathname,
    dl: location.href,
    sr: "".concat(window.screen.width, "x").concat(window.screen.height),
    vp: "".concat(window.innerWidth || document.body && document.body.clientWidth || document.clientWidth, "x").concat(window.innerHeight || document.body && document.body.clientHeight || document.clientHeight),
    uid: initialSet.userId,
    cd1: initialSet.dimension1,
    cd2: 'manual_ga_ping_nui',
    cd3: initialSet.brandingId,
    cd4: initialSet.userId,
    cd5: initialSet.dimension5,
    cd6: initialSet.dimension6,
    cd7: initialSet.dimension7,
    cd8: location.href,
    cd45: initialSet.lang,
    cd47: initialSet.concurExpenseVersion,
    cd74: initialSet.actingAsOtherUser.toString().toLowerCase(),
    cd75: "".concat(initialSet.browserNumber, "|").concat(initialSet.browserVer),
    cd76: initialSet.concurMobileEnabled.toString().toLowerCase(),
    cd77: initialSet.concurTravelVersion,
    cd79: initialSet.expenseId,
    // cd80: initialSet.expenseUserPermissions,
    cd81: initialSet.outtaskId,
    // cd82: initialSet.products,
    cd83: initialSet.propertyConfigId,
    cd84: initialSet.sessionId
    // cd85: initialSet.userRoles
  };
  // 80, 82, and 85 removed due to potential for reaching size limit

  if (params) {
    beaconParams = _objectSpread(_objectSpread({}, beaconParams), (0, _mapKeys.default)(params || {}, function (v, k) {
      return k.replace('dimension', 'cd');
    }));
  }
  if (beaconParams.t === 'event' || beaconParams.t === 'virtual.event') {
    beaconParams.ec = beaconParams.cd1;
    beaconParams.cd86 = beaconParams.ea;
    beaconParams.ea = 'manual event';
  }
  return beaconParams;
};

/*
nui common attributes
*/
var getCoreData = function getCoreData(initialSet, document, location) {
  return {
    userId: initialSet.userId,
    sessionId: initialSet.sessionId,
    outtaskId: initialSet.outtaskId,
    expenseId: initialSet.expenseId,
    companyUUID: initialSet.dimension102,
    CESEntityID: initialSet.dimension79,
    concurCoach: initialSet.concurCoach,
    lang: initialSet.lang,
    browserVer: initialSet.browserVer,
    browserNumber: initialSet.browserNumber,
    productPermissions: initialSet.dimension6 ? initialSet.dimension6.split('|') : [],
    userRoles: initialSet.userRoles ? initialSet.userRoles.split('|') : [],
    hasAdmin: initialSet.dimension7 === 'HasAdmin',
    actingAsOtherUser: initialSet.actingAsOtherUser,
    baseUrl: initialSet.dimension1,
    fullUrl: location.href,
    pageTitle: document.title,
    concurExpenseVersion: initialSet.concurExpenseVersion,
    products: initialSet.products ? initialSet.products.split('|') : [],
    expenseUserPermissions: initialSet.expenseUserPermissions ? initialSet.expenseUserPermissions.split('|') : [],
    concurTravelVersion: initialSet.concurTravelVersion,
    brandingId: initialSet.brandingId,
    theme: initialSet.theme,
    propertyConfigId: initialSet.propertyConfigId,
    concurMobileEnabled: initialSet.concurMobileEnabled
  };
};

/*
init GTM
*/
var initGtmAnalytics = exports.initGtmAnalytics = function initGtmAnalytics(settings, window, document, location, analyticsParams) {
  var _settings$initialSet = settings.initialSet,
    initialSet = _settings$initialSet === void 0 ? {} : _settings$initialSet,
    nonce = settings.nonce;
  window._analytics = _objectSpread(_objectSpread({}, window._analytics), {}, {
    q: [],
    // defining fake dispatchEvent to collect all events
    nuiDispatchEvent: function nuiDispatchEvent(target, evtType, params, analyticsMeta, state) {
      var _ref = analyticsMeta || {},
        _ref$coreData = _ref.coreData,
        overridenCoreData = _ref$coreData === void 0 ? {} : _ref$coreData,
        analyticsMetaRest = _objectWithoutProperties(_ref, _excluded);
      var defaultCoreData = getCoreData(initialSet, document, location);
      var coreData = _objectSpread(_objectSpread({}, defaultCoreData), overridenCoreData);
      var beaconParams = getBeaconParams(initialSet, evtType, window, document, location, params);
      if (window._analytics.dispatchEvent) {
        window._analytics.dispatchEvent(target, evtType, null, _objectSpread(_objectSpread({}, analyticsMetaRest), {}, {
          coreData: coreData
        }), state);
        return;
      }
      if (window._analytics.q) {
        window._analytics.q.push({
          target: target,
          evtType: evtType,
          coreData: coreData,
          beaconParams: beaconParams,
          analyticsMetaRest: analyticsMetaRest,
          state: state
        });
      }
    }
  });
  (function loadScript() {
    // prevent loading the script multiple times
    if (document.getElementById('nui-adobedtm')) return;
    var dataLayerVar = '_routingDataLayer';
    window[dataLayerVar] = window[dataLayerVar] || [];
    window[dataLayerVar].push({
      'gtm.start': Date.now(),
      event: 'gtm.js'
    });
    var gads = document.createElement('script');
    gads.id = 'nui-adobedtm';
    gads.nonce = nonce;
    gads.async = true;
    gads.type = 'text/javascript';
    // Adobe Launch url source:
    // https://wiki.concur.com/confluence/pages/viewpage.action?spaceKey=UX&title=Adobe+Launch+setup+documentation
    var launchId = '85c98625c1e8';
    if ((analyticsParams === null || analyticsParams === void 0 ? void 0 : analyticsParams.analyticsInstance) === 'dev-us' || (analyticsParams === null || analyticsParams === void 0 ? void 0 : analyticsParams.analyticsInstance) === 'dev-eu') {
      launchId = '570f1f40d72e-development';
    }
    gads.src = "//assets.adobedtm.com/e1226b306979/aeb854337dc8/launch-".concat(launchId, ".min.js");

    // https://developers.google.com/tag-manager/web/csp
    // Nonce in GTM is broken - Jira to track - UIRUN-654
    var nonceEl = document.querySelector('[nonce]');
    if (nonceEl) {
      gads.setAttribute('nonce', nonceEl.nonce || nonceEl.getAttribute('nonce'));
    }
    gads.onerror = function () {
      // looks like script failed to unload
      // clearing timout
      clearTimeout(gads.timer);

      // pinging server to memorize the fact GTM failed,
      // so we do not do it next time
      var googleTagFailureImg = document.createElement('img');
      googleTagFailureImg.style.display = 'none';
      googleTagFailureImg.src = "/ui/uipermissions/disablegtm?ts=".concat(new Date().getTime());
      document.getElementsByTagName('body')[0].appendChild(googleTagFailureImg);

      // switching to single beacon
      initSingleBeaconAnalytics(settings, window, document, location, analyticsParams);
    };
    gads.onload = function () {
      clearTimeout(gads.timer);

      // need to dispatch all accomulated events as dispatchEvent is no longer fake
      if (window._analytics.q && window._analytics.q.length > 0) {
        var dispatchAccomulatedCount = 0;
        var dispatchAccomulated = setInterval(function () {
          if (dispatchAccomulatedCount++ > 4) {
            // we are out of luck cannnot get gmt loaded
            clearInterval(dispatchAccomulated);
          }
          if (window._analytics.AutoTrackingReady) {
            var _window$_analytics;
            // looks like gmt is loaded, now need to push all accomulated events
            clearInterval(dispatchAccomulated);
            window === null || window === void 0 || (_window$_analytics = window._analytics) === null || _window$_analytics === void 0 || (_window$_analytics = _window$_analytics.q) === null || _window$_analytics === void 0 || _window$_analytics.forEach(function (cq) {
              var target = cq.target,
                evtType = cq.evtType,
                coreData = cq.coreData,
                analyticsMeta = cq.analyticsMeta,
                state = cq.state;
              window._analytics.dispatchEvent.call(window._analytics.dispatchEvent, target, evtType, null, _objectSpread(_objectSpread({}, analyticsMeta), {}, {
                coreData: coreData
              }), state);
            });
            window._analytics.q = [];
          }
        }, 1000);
      }
    };

    // some browsers are failing to fire onload  / onrror events
    // so we let it 10 sec to load, and if we are unlucky
    // we continue with singleBeacon
    gads.timer = setTimeout(function () {
      if (!window.gaGlobal) {
        // force call onerror
        gads.onerror();
      }
    }, 5000);
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(gads);
  })();
};

/*
init single beacon analytics ping
*/
var initSingleBeaconAnalytics = exports.initSingleBeaconAnalytics = function initSingleBeaconAnalytics(settings, window, document, location, analyticsParams) {
  var _settings$initialSet2 = settings.initialSet,
    initialSet = _settings$initialSet2 === void 0 ? {} : _settings$initialSet2,
    noticePreferences = settings.noticePreferences;
  var coreData = getCoreData(initialSet, document, location);
  window._analytics = _objectSpread(_objectSpread(_objectSpread({}, window._analytics), {
    nuiDispatchEvent: function nuiDispatchEvent(target, evtType, params, analyticsMeta, state) {
      var beaconParams = getBeaconParams(initialSet, evtType, window, document, location, params);
      var shouldIgnoreEvent = EVENTS_TO_IGNORE.indexOf(analyticsMeta.eventType) === -1;
      if (shouldIgnoreEvent) {
        var _window$_analytics2, _window$_analytics3;
        window === null || window === void 0 || (_window$_analytics2 = window._analytics) === null || _window$_analytics2 === void 0 || (_window$_analytics2 = _window$_analytics2.q) === null || _window$_analytics2 === void 0 || _window$_analytics2.push({
          target: target,
          evtType: evtType,
          coreData: null,
          beaconParams: beaconParams,
          analyticsMeta: analyticsMeta,
          state: state
        });
        if ((window === null || window === void 0 || (_window$_analytics3 = window._analytics) === null || _window$_analytics3 === void 0 || (_window$_analytics3 = _window$_analytics3.q) === null || _window$_analytics3 === void 0 ? void 0 : _window$_analytics3.length) === 1) {
          _nuiDispatchEvent();
        }
      }
    }
  }), {
    q: (0, _get2.default)(window, '_analytics.q', [])
  });
  window._analytics.dispatchEvent = window._analytics.nuiDispatchEvent;
  function _nuiDispatchEvent() {
    if (window._analytics.q.length === 0) {
      return;
    }

    // grab first from queue and send
    var _get = (0, _get2.default)(window._analytics, 'q[0]', []),
      evtType = _get.evtType,
      beaconParams = _get.beaconParams;
    if (evtType === null) {
      return;
    }
    beaconParams.t = beaconParams.t.replace('virtual.', '');
    var analyticsId = coreData.userId,
      companyUUID = coreData.companyUUID,
      brandingId = coreData.brandingId,
      lang = coreData.lang,
      entityid = coreData.CESEntityID,
      theme = coreData.theme;
    var newDate = new Date();
    var date = newDate.getDate();
    var month = newDate.getMonth() + 1;
    var year = newDate.getFullYear();
    var hour = newDate.getHours();
    var minutes = newDate.getMinutes();
    var seconds = newDate.getSeconds();
    var day = newDate.getDay();
    var offset = newDate.getTimezoneOffset();
    var _ref2 = analyticsParams || {},
      region = _ref2.region;
    if (region === 'us' || region === 'eu' || region === 'apac') {
      var manualPing = analyticsParams.manualPing,
        analyticsInstance = analyticsParams.analyticsInstance,
        productDataCenterSiteTypeOS = analyticsParams.productDataCenterSiteTypeOS;
      var pingParams = {
        AQB: 1,
        pf: 1,
        t: "".concat(date, "/").concat(month, "/").concat(year, " ").concat(hour, ":").concat(minutes, ":").concat(seconds, " ").concat(encodeURIComponent(day), " ").concat(offset),
        vid: analyticsId,
        ce: document.characterSet,
        pagename: location.pathname,
        g: location.href,
        r: document.referrer,
        v1: productDataCenterSiteTypeOS,
        v2: analyticsId,
        v3: companyUUID,
        v4: location.hostname,
        v5: location.pathname,
        v6: document.title,
        v7: navigator.userAgent,
        v24: manualPing,
        v25: brandingId,
        v31: lang,
        v42: 'no gtm',
        v51: entityid,
        v54: theme,
        s: "".concat(window.innerWidth || document.body && document.body.clientWidth || document.clientWidth, "x").concat(window.innerHeight || document.body && document.body.clientHeight || document.clientHeight),
        c: screen.colorDepth,
        bw: window.outerWidth,
        bh: window.outerHeight,
        AQE: 1
      };
      var encodedPingParamsURLString = Object.entries(pingParams).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v));
      }).join('&');

      // seems like the simplest way to "disable" the beacon ping for now is to
      // just not emit the <img> tag if the notice_preferences cookie is 0 (required)
      // there has to be a better way to handle this, but trying to minimize churn for now
      var adobeAnalyticsManualBeaconPingURL = "https://concursolutions".concat(region, ".sc.omtrdc.net/b/ss/concursolutions-").concat(analyticsInstance, "-data-center/1?").concat(encodedPingParamsURLString);
      if (noticePreferences !== 0) {
        var beaconImg = document.createElement('img');
        beaconImg.style.display = 'none';
        beaconImg.src = adobeAnalyticsManualBeaconPingURL;
        beaconImg.onload = function () {
          // remove sent from array, and call _nuiDispatchEvent to send the next one
          window._analytics.q.shift();
          _nuiDispatchEvent();
        };
      }
    }
  }
  // execute push first time
  _nuiDispatchEvent();
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return state;
}